export default {
  colors: {
    PRIMARY: '#2C5276',
    SECONDARY: '#DADADA',
    WHITE: '#fff',
    IMPORTANT: '#CE2222',
    BACKGROUND: '#E5E5E5',
    BOARD: '#F4F5F6',
  },
};
